"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./validate-email.component.css.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./validate-email.component");
var i3 = require("@angular/router");
var i4 = require("../../Services/service.service");
var styles_ValidateEmailComponent = [i0.styles];
var RenderType_ValidateEmailComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ValidateEmailComponent, data: {} });
exports.RenderType_ValidateEmailComponent = RenderType_ValidateEmailComponent;
function View_ValidateEmailComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
exports.View_ValidateEmailComponent_0 = View_ValidateEmailComponent_0;
function View_ValidateEmailComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-validate-email", [], null, null, null, View_ValidateEmailComponent_0, RenderType_ValidateEmailComponent)), i1.ɵdid(1, 114688, null, 0, i2.ValidateEmailComponent, [i3.ActivatedRoute, i4.MainService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_ValidateEmailComponent_Host_0 = View_ValidateEmailComponent_Host_0;
var ValidateEmailComponentNgFactory = i1.ɵccf("app-validate-email", i2.ValidateEmailComponent, View_ValidateEmailComponent_Host_0, {}, {}, []);
exports.ValidateEmailComponentNgFactory = ValidateEmailComponentNgFactory;
